import React, { useRef } from 'react'
import { useRouter } from 'next/router'
import { useTranslation, UseTranslation } from 'next-i18next';

interface CategoryTabsProps {
  categories: { id: number; slug: string; name: {
    ar: string;
    en: string;
  } }[]
  currentCategory: string | string[] | undefined
  productType: string
  childName: string | undefined
  productsQuery: any
  childGender: string
  is_ai?: string
}

export default function CategoryTabs({
  categories,
  currentCategory,
  productType,
  childName,
  productsQuery,
  childGender,
  is_ai
}: CategoryTabsProps) {
  const {t} = useTranslation('categoryTabs');
  const router = useRouter()
  const containerRef = useRef<HTMLDivElement>(null)
  const tabRefs = useRef<{ [key: string]: HTMLDivElement | null }>({})

  const genderFromUrl =
    router.query.options != undefined
      ? (router.query.options as string)
      : childGender

  const handleClick = (slug: string, aiFlag?: string) => {
    const cats = slug ? [slug] : [];

    const params = new URLSearchParams({
      product_type: productType,
      options: genderFromUrl || '',
      categories: cats.join(','),
      query: productsQuery || '',
      sort: '',
      name: childName || '',
      count: '',
      page: '1', // 👈 IMPORTANT: reset page
      minPrice: '',
      maxPrice: ''
    });

    if (aiFlag) {
      params.set('is_ai', aiFlag);
    } else {
      params.delete('is_ai'); // 👈 clear when switching back
    }

    router.push('/products?' + params.toString(), undefined, {
      scroll: false
    });
  };

  const {locale} = useRouter();

  const renderTab = (
    slug: string,
    label: any,
    isActive: boolean,
    aiFlag?: string
  ) => (
    <div
      key={slug || 'all'}
      ref={(el) => {
        tabRefs.current[slug + (aiFlag || '')] = el;
      }}
      className={`pb-2 text-black text-center text-base whitespace-nowrap border-b-2 ${
        isActive
          ? 'border-[#272727] font-normal'
          : 'border-transparent font-light'
      }`}
      onClick={() => handleClick(slug, aiFlag)} // ✅ pass aiFlag
    >
      {label}
    </div>
  )

  return (
    <div
      ref={containerRef}
      className={`flex lg:hidden items-center gap-12 overflow-x-auto hide-scrollbar mt-4 mb-3 border-b border-[#FBEAEA] [&>*:first-child]:-mr-10 ${locale === 'ar' ? 'pr-10' : ''}`}
    >
      {renderTab(
        '',
        productType === '1' ? t('allStorybooks') : t('allNotebooks'),
        (!currentCategory && (is_ai === '0' || !is_ai))
      )}

      {productType === '1' && renderTab(
        '',
        t('aiStories') || 'AI Stories',
        is_ai === '1', // Active when is_ai=1
        '1'
      )}

      {productType === '1' &&
        categories
          .filter((cat) => !cat.name?.ar?.includes('صورة'))
          .map((cat) =>
            renderTab(
              cat.slug, 
              (locale === 'ar' ? cat?.name?.ar : cat?.name?.en), 
              currentCategory === cat.slug && !is_ai,
              undefined // No AI flag for regular categories
            )
          )
      }

      {productType === '2' &&
        categories
          .filter((cat) => cat.name?.ar?.includes('صورة'))
          .map((cat) =>
            renderTab(cat.slug, (locale === 'ar' ? cat?.name?.ar : cat?.name?.en), currentCategory === cat.slug)
          )}
    </div>
  )
}